module.exports = __webpack_public_path__ + "static/media/home-icon.0240b54c.svg";